import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import AppButton from '../../styles/common/AppButton';
import Call from '../Icons/Call';
import CallEnd from '../Icons/CallEnd';
import { PAGE_PATH, REMOTE_COMMAND } from '../../lib/constants';
import { getCallingRoomMembers } from '../../actions/api/apis';
import ColorSF2 from '../../styles/common/ColorSF2';

const Wrapper = styled.div`
  z-index: 1001; // 入室待ちルーム一覧ダイアログの背景より上であること
  position: absolute;
  top: 0;
  width: 100vw;
  height: 50px;
  padding: 10px;
  background-color: ${ColorSF2.darkGrayTransparent};
  display: flex;
  justify-content: space-between;
  align-items: center;
  transform: translateZ(0px);
  transition:
    left 0ms cubic-bezier(0.23, 1, 0.32, 1) ${props => (props.open ? 0 : 400)}ms,
    opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
`;
const MessageWrapper = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${ColorSF2.white};
`;
const Buttons = styled.div`
  display: flex;
  align-items: center;
`;
const Button = styled(AppButton)`
  width: 80px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
`;

const IncomingAlertBar = ({
  apiToken,
  dispatch,
  incomingAlertTarget,
  callingRooms,
}) => {
  const reject = () => dispatch({ type: 'REJECT_REMOTE_INCOMING' });
  const answer = () => dispatch({ type: 'REJECT_REMOTE_INCOMING' });
  const { appRoomId, caller } = incomingAlertTarget;
  const { name } = caller;
  const remoteUrl = `${PAGE_PATH.DS_REMOTE}/pre/${REMOTE_COMMAND.answer}?appRoomId=${appRoomId}`;
  useEffect(() => {
    const appRoomIds = callingRooms.map(({ appRoomId: workId }) => workId);
    dispatch(getCallingRoomMembers(apiToken, appRoomIds));
    window.setTimeout(() => {
      dispatch({ type: 'NOTANSWER_REMOTE_INCOMING' });
    }, 60000);
  }, [dispatch, apiToken, callingRooms]);
  return (
    <Wrapper>
      <MessageWrapper>
        <FormattedMessage
          id="remote.incoming.alert.message"
          values={{ name }}
        />
      </MessageWrapper>
      <Buttons id="remote_answer_buttons">
        <Button
          className="button"
          bgColor={ColorSF2.red}
          onClick={() => reject()}
        >
          <CallEnd color="white" width="20px" />
          <FormattedMessage id="remote.incoming.alert.button.reject" />
        </Button>
        <Link to={remoteUrl} target="_blank" onClick={answer}>
          <Button
            className="button"
            bgColor={ColorSF2.green}
            onClick={() => answer()}
          >
            <Call color="white" width="20px" />
            <FormattedMessage id="remote.incoming.alert.button.answer" />
          </Button>
        </Link>
      </Buttons>
    </Wrapper>
  );
};

IncomingAlertBar.propTypes = {
  apiToken: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  incomingAlertTarget: PropTypes.object.isRequired,
  callingRooms: PropTypes.array.isRequired,
};

export default IncomingAlertBar;
